import { BaseRoutes } from '@monorepo/tools/src/lib/routes/base.routes';

export class DomainMaxLossRoutes extends BaseRoutes {
	constructor() {
		super('domain-max-loss');
	}
}
